
import { Component, Input, OnInit, Output, EventEmitter } from "@angular/core";
import { AuthorizationPipe } from "../../common/pipes/authorization.pipe";
import { CustomerService } from "../services/customer.service";
import { ProfileInformation } from "../interface/profile-info";
import { AddressInformation } from "../interface/address-detail-info";
import { ActivatedRoute, Params, Router } from '@angular/router';
import { DatePipe } from "@angular/common";
import { environment } from "../../../environments/environment";
import { SponsorInformation } from "../interface/sponsor-information";
import { AccountModel } from "../models/account-model";
import { MemberType } from "../common/constants";
import { CacheService } from "../../shared/services/cache.service";
import { CacheKey } from "../../shared/constants/cachekey.constants";
import { Permission } from "../../common/enums/permission.enum";
import { AccessLevel } from "../../common/enums/access-level.enum";

@Component({
    selector: "retail-profile",
    templateUrl: "../templates/template1/views/retail-profile.component.html",
    styleUrls: [
        "../templates/template1/themes/default/css/profile-info.less"
    ],
    providers: [AuthorizationPipe, CustomerService, DatePipe]
})

export class RetailProfileComponent implements OnInit {
    @Input() retailerid: string;
    details: any;
    retailProfileInformation: any;
    _id: string; // stores fbo id 
    userId: number;
    impersonationPermission: any[] = [Permission.IMPERSONATION];
    customerServiceAccessLevelId: number= AccessLevel.Customer_Service;
    
    constructor(private _customerservice: CustomerService
        , private route: ActivatedRoute
        , private router: Router
        , private _customerService: CustomerService
        , private _cacheService: CacheService) { }
    ngOnInit(): void {
        // this.route.params.subscribe((params: Params) => {
        //     this._id = params["id"];
        // });
        this._id = this.retailerid;
        this.retailProfileInformation = new ProfileInformation();
        this.retailProfileInformation.address = new AddressInformation();
        this.retailProfileInformation.sponsorDetails = new SponsorInformation();
        this.userId = this._cacheService.get(CacheKey.UserId);
        this.getProfileInfo();
    };

    /** * HITS SERVICES   ----- BEGIN ----- ************************* */
    /**
     * Gets fbo/retail profile detail
     */
    getProfileInfo() {
        this._customerservice.getRetailProfileInformation(this._id).subscribe(response => {
            if (response) {
                this.retailProfileInformation = response;
                if (!this.retailProfileInformation.address) {
                    this.retailProfileInformation.address = new AddressInformation();
                }
                this.retailProfileInformation.enrollmentDate = new Date(response.enrollmentDate);
                this.retailProfileInformation.firstPurchaseDate = new Date(response.firstPurchaseDate);
                this.retailProfileInformation.birthDate = new Date(response.birthDate);
                if (!this.retailProfileInformation.sponsorDetails) {
                    this.retailProfileInformation.sponsorDetails = new SponsorInformation();
                }
                this.saveRecentlyViewedAccount();
            }
        });
    };

    impersonate(userName: any): void {
        this._customerService.getAdminToken().subscribe(response => {
            this._customerService.impersonate(response, userName,"TITAN").subscribe(res => {
                window.open(environment.shopURL + "?impersonation=true", "_blank");
            });
        });
    }

    saveRecentlyViewedAccount(): void {
        let accountModel = new AccountModel();
        accountModel.id = 0;
        accountModel.memberType = MemberType.RETAIL;
        accountModel.memberAccountId = this.retailProfileInformation.userName;
        accountModel.memberAccountName = this.retailProfileInformation.firstName + (this.retailProfileInformation.lastName != null ? (" " + this.retailProfileInformation.lastName) : "");
        accountModel.customerAgentId = this.userId;
        this._customerservice.saveRecentlyViewedAccount(accountModel)
            .subscribe(response => {
            }, error => {
            });
    }
};


// WEBPACK FOOTER //
// ./src/app/customerservice/components/retail-profile.component.ts